export default {
  "grace": {
    "title": "原订阅续费异常",
    "hint": "原订阅处于宽限期或欠费续费状态。请先取消原订阅，刷新状态后再充值。",
    "action": "取消原订阅并重新检测",
    "confirm": "确认取消这个账号宽限期内的原订阅？可能立即结束宽限期权益。处理后只刷新状态，需要再次点击兑换，不会自动消耗 CDK 或扣款。",
    "pending": "原订阅尚未确认解除，请重新检测账号。不要连续重复取消或兑换。",
    "done": "原订阅已解除，状态已刷新。核对套餐后可再次点击兑换。",
    "refreshFailed": "暂时无法确认处理结果，请重新检测账号，不要重复取消。",
    "processing": "正在处理并刷新…",
    "recheck": "重新检测账号",
    "dismiss": "暂不处理",
    "confirmAction": "确认取消"
  },
  "common": {
    "back": "← 返回",
    "backHome": "← 返回首页",
    "loading": "加载中...",
    "submitting": "提交中...",
    "querying": "查询中...",
    "retry": "重新查询",
    "switchLight": "切换到亮色",
    "switchDark": "切换到暗色"
  },
  "home": {
    "brand": "Recharge Portal",
    "brandSub": "Account Upgrade Service",
    "heroTitle": "充值与账户升级服务",
    "heroSub": "按步骤校验账号、卡密并确认信息",
    "flowTitle": "操作流程",
    "services": {
      "recharge": {
        "title": "充值提交",
        "en": "Recharge Portal",
        "cta": "开始充值",
        "p1": "验证 CDK 卡密",
        "p2": "提交 Session",
        "p3": "确认提交申请"
      },
      "batch": {
        "title": "批量兑换",
        "en": "Batch Redeem",
        "cta": "批量开始",
        "p1": "批量验证 CDK",
        "p2": "导入 Excel Session",
        "p3": "按序配对自动提交"
      },
      "lookup": {
        "title": "卡密查询",
        "en": "CDK Status",
        "cta": "查询卡密",
        "p1": "输入完整卡密",
        "p2": "查看是否已使用",
        "p3": "显示充值邮箱"
      },
      "billing": {
        "title": "账单查询",
        "en": "Billing Tool",
        "cta": "查询账单",
        "p1": "粘贴 Session",
        "p2": "查询账单信息",
        "p3": "查看订阅状态"
      }
    },
    "flows": {
      "submit": {
        "title": "提交流程",
        "s1": "CDK 验证 — 匹配套餐和状态",
        "s2": "提交 Session — 粘贴 chatgpt.com/api/auth/session 的 JSON",
        "s3": "确认提交 — 阅读协议后确认"
      },
      "batch": {
        "title": "批量兑换",
        "s1": "验证 CDK — 批量预览卡密",
        "s2": "导入 Session — Excel/CSV 自动识别",
        "s3": "配对提交 — 按序兑换并看进度"
      },
      "lookup": {
        "title": "卡密查询",
        "s1": "输入卡密 — 完整 CDK",
        "s2": "查询状态 — 是否已使用",
        "s3": "查看邮箱 — 充值到哪个账号"
      },
      "billing": {
        "title": "账单查询",
        "s1": "Session 输入 — 粘贴 Token",
        "s2": "查询账单 — 点击查询后进入",
        "s3": "账单结果 — 查询后展示"
      }
    },
    "eyebrow": "SECURE CDK REDEEM DESK",
    "trustNote": "加密传输 · 仅用于完成本次充值服务",
    "statusLabel": "系统服务状态",
    "systemOnline": "系统运行正常",
    "availability": "全天候服务",
    "serviceNav": "服务导航",
    "serviceNavSub": "选择服务，快速进入对应流程",
    "flowSub": "步骤清晰，结果全程可查",
    "status": {
      "api": "实时校验",
      "cdk": "记录可查",
      "ssl": "安全连接"
    }
  },
  "redeemTabs": {
    "single": "立即兑换",
    "batch": "批量充值",
    "lookup": "卡密查询",
    "billing": "账单查询",
    "singleMeta": "Single Redeem",
    "batchMeta": "Batch Redeem",
    "lookupMeta": "CDK Status",
    "billingMeta": "Billing Check",
    "tutorial": "使用教程",
    "tutorialMeta": "Quick Start",
    "navLabel": "更多服务"
  },
  "batch": {
    "title": "批量兑换",
    "subtitle": "验证 CDK → Session 或邮箱密码配对 → 按序提交看进度",
    "panelTitle": "批量充值",
    "panelHint": "验证 CDK → 选择 Session 或邮箱密码 → 按顺序配对提交",
    "cdkListLabel": "卡密列表（每行一个，最多 {max}）",
    "cdkPlaceholder": "ZC-XXXXXXXXXX-XXXXXXXXXX\n…",
    "cdkRecognized": "已识别 {n} 个卡密",
    "cdkQueueHint": "大批量将并发排队处理，请确保上游额度充足",
    "credMode": "凭证方式",
    "modeSession": "Session",
    "modeMailbox": "邮箱密码",
    "mailboxLabel": "邮箱密码列表（每行一个）",
    "mailboxPlaceholder": "email----password\nemail:password\nemail,password",
    "mailboxLinePlaceholder": "email----password 或 email:password",
    "mailboxRecognized": "已识别 {n} 条邮箱密码",
    "mailboxImportBtn": "导入 Excel / CSV / TXT（邮箱+密码）",
    "mailboxHint": "支持 mail.tm / Outlook。格式：email----password；Excel 需含「邮箱」「邮箱密码」列",
    "mailboxPairHint": "配对规则：第 1 张有效 CDK ↔ 第 1 条邮箱密码，依次类推。下方看实时进度（含账号与卡尾号）。",
    "excelLabel": "Session Excel（可选）",
    "clearImport": "清空已导入",
    "importing": "识别中…",
    "imported": "已导入 {n} 条 · 点击更换",
    "importBtn": "导入 Excel / CSV（自动识别 session 列）",
    "excelHint": "支持 xlsx / csv。gptbuy 格式「邮箱,邮箱密码,GPT密码,token,session」自动用 session 列；兑换需完整 JSON（含 sessionToken）或五段 JWE，不能只用 Access Token",
    "verifying": "验证中…",
    "verifyStart": "批量验证并开始",
    "verifyingKeys": "正在批量验证卡密…",
    "statTotal": "全部",
    "statWait": "待凭证",
    "statRun": "处理中",
    "statOkFail": "成功/失败",
    "currentOrdinal": "第 {n} / {total} 张",
    "remaining": "剩余 {n} 待贴",
    "willUseAccount": "将使用账号：",
    "sessionPlaceholder": "粘贴完整 Session JSON（须含 sessionToken）或五段 JWE；导入后自动填入",
    "submitting": "提交中…",
    "submitNext": "提交并继续下一张",
    "autoSubmitting": "自动提交中…",
    "autoSubmit": "一键自动提交（卡密×凭证按序配对，池内 {n} 条）",
    "pairHint": "配对规则：第 1 张有效 CDK ↔ Excel 第 1 条 Session，依次类推。提交后后台处理，下方看进度。",
    "allSubmitted": "全部凭证已提交（{n} 笔）",
    "watchProgress": "下方可继续查看处理进度",
    "exportOk": "导出本批成功号（{n}）",
    "noValidKeys": "没有可兑换的有效卡密",
    "liveProgress": "实时进度",
    "account": "账号",
    "card": "银行卡",
    "cardPending": "开卡后显示尾号",
    "reset": "返回 · 重新开始",
    "status": {
      "pending_verify": "待验证",
      "verify_ok": "卡密有效",
      "verify_fail": "卡密无效",
      "waiting_session": "待凭证",
      "submitting": "提交中",
      "processing": "处理中",
      "success": "成功",
      "failed": "失败"
    }
  },
  "recharge": {
    "title": "充值提交",
    "subtitle": "Recharge Portal · 账号充值申请",
    "steps": {
      "s1": "验证卡密",
      "s2": "账号凭证",
      "s3": "确认兑换",
      "s4": "充值结果"
    },
    "step1Title": "验证 CDK 卡密",
    "cdkLabel": "CDK 卡密",
    "cdkValid": "✓ CDK 有效",
    "planType": "套餐类型",
    "cdkTypesHint": "当前支持的 CDK 类型为 pro、5x、20x。",
    "verifying": "验证中...",
    "next": "下一步 →",
    "prev": "← 上一步",
    "step2Title": "提交 Session",
    "howToGetSession": "如何获取 Session？",
    "sessionGuidePrefix": "登录 ChatGPT 后，在浏览器打开",
    "sessionGuideSuffix": "，将页面返回的完整 JSON 全部复制，粘贴到下方输入框。",
    "sessionLabel": "Session JSON",
    "sessionHint": "粘贴从 chatgpt.com/api/auth/session 获取的完整 Session JSON",
    "sessionWarn": "⚠ 请粘贴完整的 Session JSON，系统会在提交前进行验证",
    "step3Title": "确认提交",
    "sessionStatus": "Session 状态",
    "sessionFilled": "✓ 已填写",
    "agreePrefix": "我已阅读并同意",
    "terms": "用户协议",
    "and": "和",
    "privacy": "隐私政策",
    "submitSuccessTitle": "✓ 申请已提交成功！",
    "taskId": "任务ID",
    "submitSuccessHint": "提交成功。可用「卡密查询」查看是否已使用及充值邮箱。",
    "confirmSubmit": "确认提交",
    "errInvalidCdk": "CDK无效",
    "errVerifyFailed": "验证失败",
    "errCreateFailed": "创建任务失败",
    "errConfirmFailed": "确认失败",
    "errNetwork": "网络错误",
    "eyebrow": "SECURE RECHARGE PORTAL",
    "portalTitle": "GPT充值系统",
    "portalSubtitle": "专业 · 安全 · 快捷 · 全程可追踪",
    "trustEncrypted": "全程加密传输",
    "trustRealtime": "实时进度追踪",
    "trustTraceable": "结果随时可查",
    "online": "系统运行正常",
    "encrypted": "端到端加密传输",
    "workflowTitle": "兑换充值",
    "secureChannel": "安全通道已连接",
    "step1Subtitle": "输入完整卡密，系统将自动校验套餐与可用状态。",
    "verify": "验证卡密",
    "previewValid": "卡密有效，可以继续兑换",
    "cardHelpTitle": "卡密仅用于本次校验",
    "cardHelpBody": "系统不会公开您的卡密、账号凭证或充值结果。",
    "step2Subtitle": "粘贴完整 Session，用于核验目标账号与订阅状态。",
    "mailboxMode": "邮箱密码",
    "sessionPrivacy": "仅用于本次账号验证和充值",
    "sessionPlaceholder": "粘贴完整 Session JSON（必须包含 sessionToken）",
    "sessionInvalid": "请粘贴完整 Session JSON（必须含 sessionToken），不能只用 Access Token",
    "sessionCheckFailed": "Session 校验失败，请重新登录 ChatGPT 后获取完整 Session",
    "emailLabel": "登录邮箱",
    "passwordLabel": "邮箱密码",
    "passwordPlaceholder": "输入邮箱密码",
    "preflighting": "预检中...",
    "preflight": "验证账号",
    "step3Subtitle": "核对账号与套餐信息，确认无误后提交兑换。",
    "verifiedAccount": "VERIFIED ACCOUNT",
    "accountVerified": "账号已验证",
    "planSatisfied": "当前套餐已满足",
    "redeemNow": "确认兑换",
    "resultTitle": "兑换进度",
    "resultSubtitle": "请保持当前页面开启，系统会自动同步最新处理结果。",
    "sideHints": {
      "s1": "先核验卡密的有效性与对应套餐，不会在此步骤消耗卡密。",
      "s2": "凭证只用于本次账号预检与充值，不会在页面公开展示。",
      "s3": "提交前再次核对目标账号、当前订阅状态与套餐信息。",
      "s4": "系统持续轮询处理状态，遇到 pending 或 review 时请勿重复提交。"
    },
    "featureSecure": "加密通道",
    "featureTraceable": "进度可追踪",
    "guideTitle": "使用教程",
    "guideSubtitle": "四个步骤完成卡密兑换，无需注册或登录本站账号。",
    "guide": {
      "g1": {
        "title": "验证卡密",
        "body": "输入完整 CDK，确认卡密有效并查看对应套餐。"
      },
      "g2": {
        "title": "提交凭证",
        "body": "先在浏览器中登录gpt账号，再复制并粘贴包含 sessionToken 的完整 Session JSON。"
      },
      "g3": {
        "title": "核对信息",
        "body": "检查目标邮箱、当前套餐及订阅状态，确认后提交。"
      },
      "g4": {
        "title": "等待结果",
        "body": "页面会自动更新进度，完成后可通过卡密查询再次核对。"
      }
    },
    "footer": "Secure CDK Redeem Service",
    "targetPlan": "目标套餐",
    "currentPlan": "当前套餐",
    "subscriptionStatus": "订阅状态",
    "expiresAt": "套餐到期",
    "remainingTime": "剩余",
    "autoRenew": "自动续费",
    "lastPaymentAt": "最近付款时间",
    "lastPayment": "最近付款",
    "paymentMethod": "支付方式",
    "unavailable": "上游未提供",
    "accountUnavailable": "账号摘要暂不可用",
    "accountUnavailableHint": "仍可继续兑换，最终以系统校验结果为准。",
    "syncing": "正在实时同步最新进度",
    "processingEnded": "处理已结束",
    "redeemAccount": "兑换账号",
    "bankCard": "银行卡",
    "cardPending": "开卡后显示尾号",
    "redeemFailedHint": "本次兑换未成功。可在「卡密查询」中查看卡密状态，确认可重新提交后再试。",
    "redeemCompleteHint": "开通完成，请到 ChatGPT 账号确认套餐。",
    "redeemAnother": "再兑一张",
    "active": "有效",
    "expiredFree": "已到期 / 免费版",
    "willRenew": "到期后自动续费",
    "willNotRenew": "到期后不续费",
    "paid": "已支付",
    "defaultPayment": "默认支付方式",
    "expired": "已到期",
    "successHeadline": "充值成功",
    "failedHeadline": "充值未成功",
    "reviewHeadline": "审核中，请稍候",
    "queuedHeadline": "已提交，排队处理中",
    "processingHeadline": "正在处理",
    "queuedStep": "排队受理",
    "credentialStep": "凭证校验",
    "pricingStep": "计价",
    "checkoutStep": "开卡/绑卡",
    "paymentStep": "支付扣款",
    "subscriptionStep": "订阅生效",
    "invoiceStep": "账单",
    "renewalStep": "续费处理",
    "reconcileStep": "对账确认",
    "completedStep": "完成",
    "processingStep": "处理中",
    "acceptProgress": "受理",
    "cardProgress": "开卡/资金",
    "payProgress": "支付",
    "doneProgress": "开通",
    "enterCdk": "请输入 CDK",
    "unavailableCdk": "CDK 无效或不可用",
    "missingRedemptionToken": "未返回 redemption_token，请检查卡台 Base 配置",
    "mailboxRequired": "请填写邮箱与密码",
    "preflightFailed": "预检失败",
    "missingPreflightToken": "未返回 preflight_token",
    "redeemRejected": "兑换被拒绝",
    "sessionInstructions": "先在浏览器中登录gpt账号，并打开 {link} 复制{json}（必须含 {token}）。",
    "completeJson": "完整 JSON",
    "freePlan": "免费版",
    "renewalPlan": "Pro 20x 续费",
    "cardExpiry": "卡片到期 {date}",
    "satisfiedRenewing": "账号已有 {plan} 或更高套餐，当前周期至 {date} 并会自动续费，取消并到期前不能重复购买。",
    "satisfiedUntil": "账号已有 {plan} 或更高套餐，最早可在 {date} 后再次购买。",
    "satisfiedCurrent": "账号已有 {plan} 或更高套餐，当前周期至 {date}，暂不能重复购买。",
    "satisfied": "账号已有 {plan} 或更高套餐，本次不能重复购买。",
    "daysHours": "{days} 天 {hours} 小时",
    "hoursMinutes": "{hours} 小时 {minutes} 分钟",
    "minutes": "{minutes} 分钟",
    "displaySettings": "显示设置",
    "close": "关闭"
  },
  "cdkLookup": {
    "title": "卡密查询",
    "subtitle": "查询卡密是否已使用，以及充值到哪个邮箱（不查询 token）",
    "queryTitle": "输入卡密",
    "queryHint": "输入完整卡密，系统仅返回使用状态与充值邮箱，不会返回 session / token。",
    "modeSingle": "单张查询",
    "modeBatch": "批量查询",
    "batchHint": "每行一张，也可用空格 / 逗号分隔。一次最多 {max} 张，不返回 session / token。",
    "batchLabel": "卡密列表",
    "batchPlaceholder": "SXC-XXXX-XXXX-XXXX-XXXX\nSXC-YYYY-YYYY-YYYY-YYYY",
    "batchRecognized": "已识别 {n} 张",
    "batchTruncated": "超过上限，仅查询前 {max} 张",
    "batchQueryBtn": "批量查询",
    "batchEmpty": "请先粘贴至少一张卡密",
    "copyEmails": "复制已用邮箱",
    "exportCsv": "导出 CSV",
    "copied": "已复制",
    "copyFail": "复制失败",
    "summaryUsed": "使用成功 {n}",
    "summaryFailed": "使用失败 {n}",
    "summaryUnused": "未使用 {n}",
    "summaryProcessing": "处理中 {n}",
    "summaryUnknown": "未找到 {n}",
    "cdkLabel": "CDK 卡密",
    "cdkPlaceholder": "SXC-XXXX-XXXX-XXXX-XXXX",
    "queryBtn": "查询卡密状态",
    "resultTitle": "查询结果",
    "cdkCode": "卡密",
    "useStatus": "使用结果",
    "rechargeEmail": "充值邮箱",
    "emailEmpty": "—",
    "plan": "套餐",
    "usedAt": "使用时间",
    "queryOther": "查询其他卡密",
    "resubmit": "重新提交",
    "goRedeem": "去兑换",
    "msgUsed": "该卡密使用成功。",
    "msgFailed": "该卡密使用失败。",
    "msgUnused": "该卡密尚未使用。",
    "msgProcessing": "该卡密兑换处理中。",
    "errNotFound": "未找到该卡密记录",
    "errNetwork": "网络错误，请重试",
    "status": {
      "unused": "未使用",
      "used": "使用成功",
      "failed": "使用失败",
      "disabled": "已禁用",
      "expired": "已过期",
      "processing": "处理中",
      "unknown": "未知"
    }
  },
  "dashboard": {
    "title": "账单工具",
    "subtitle": "Billing Tool · 查询账号订阅和账单信息",
    "step1Title": "粘贴 Session 发起查询",
    "hint": "粘贴需要查询账单的 Session JSON 或 access token。",
    "inputLabel": "Session JSON 或 access token",
    "inputPlaceholder": "粘贴 Session JSON 或 access token",
    "inputExample": "例如: {\"access_token\":\"sk-xxx\"} 或直接粘贴 token",
    "queryBtn": "查询账单",
    "resultTitle": "账单结果",
    "accountInfo": "账号信息",
    "email": "邮箱地址",
    "subStatus": "订阅状态",
    "currentPlan": "当前计划",
    "billingInfo": "账单信息",
    "billingAmount": "账单金额",
    "currency": "货币",
    "nextBilling": "下次计费日期",
    "queryOther": "查询其他账号",
    "notFoundTitle": "未找到该 Session 对应的账单",
    "notFoundHint": "请检查 Session 是否输入正确",
    "msgActive": "✓ 订阅激活，账号处于正常状态",
    "msgInactive": "⚠ 订阅未激活，请检查账单信息",
    "msgExpired": "✗ 订阅已过期，请更新支付信息",
    "errQueryFailed": "查询失败",
    "errNetwork": "网络错误，请重试",
    "status": {
      "active": "激活",
      "inactive": "未激活",
      "expired": "已过期"
    }
  },
  "login": {
    "title": "管理员登录",
    "subtitle": "登录后才能进入管理后台、CDK 管理和账单上传。",
    "username": "用户名",
    "usernamePlaceholder": "请输入用户名",
    "password": "密码",
    "passwordPlaceholder": "请输入密码",
    "loginBtn": "登录后台",
    "loggingIn": "登录中...",
    "errLoginFailed": "登录失败",
    "errNetwork": "网络错误，请稍后重试"
  },
  "notFound": {
    "title": "页面不存在",
    "home": "返回首页"
  }
}
